import { SubZone } from '../../interfaces'
import { SubZoneAction } from '../actions/subzoneActions'
import { GET_SUBZONES_EXITO } from '../types/subzoneActionsTypes'

export interface SubZoneState {
  subzonesState: {
    subzones?: SubZone[] | undefined
    error?: string | undefined
  }
}

const initialState: SubZoneState = {
  subzonesState: { subzones: [], error: '' }
}

export const subzoneReducer = (
  state: SubZoneState = initialState,
  action: SubZoneAction
): SubZoneState => {
  if (action.type === GET_SUBZONES_EXITO) {
    return {
      ...state,
      subzonesState: {
        subzones: action.subzones,
        error: action.error
      }
    }
  }
  return state
}
